import { SplitLayoutProps } from "./SplityLayout.types";
import styles from "./SplitLayout.module.scss";

export const SplitLayout = ({
  children,
  className = "",
}: SplitLayoutProps) => (
  <section className={`${styles.splitLayout} ${className}`}>
    {children}
  </section>
);
